import { loadContext } from 'src/api/loaders';
import type { RoutesFunc } from 'src/routes/routes';

import { AdminContainer, OptimizerLiteContext } from './container';
import { OptimizerLiteDashboard } from './optimizer-lite-dashboard';
import { OptimizerLiteGenerations } from './optimizer-lite-generations';
import { SelectProduct } from './optimizer-lite-select';
export const routes: RoutesFunc = () => [
  {
    path: '/optimizer-lite',
    id: 'optimizer-lite',
    loader: () => loadContext<OptimizerLiteContext>(),
    Component: AdminContainer,
    children: [
      {
        index: true,
        id: 'home',
        Component: SelectProduct,
      },
      {
        path: 'dashboard',
        id: 'dashboard',
        Component: OptimizerLiteDashboard,
      },
      {
        path: 'generations/:liteGenerationGroupId',
        id: 'generations',
        Component: OptimizerLiteGenerations,
      },
    ],
  },
];
